import React from 'react';
import Accent from '@/components/typography/Accent';
import Paragraph from '@/components/typography/Paragraph';

const DataVisualization = () => (
  <>
    <Paragraph>
      I had the opportunity take part in the <Accent>Information is Beautiful workshop</Accent> lead by David McCandless, which was a good insight on <Accent>'How to do dataviz'</Accent>, from defining your metrics to designing impactful charts and diagrams.
    </Paragraph>
    <Paragraph>
      Over the past year I created and implemented few data visualizations for an in-house application, giving insights to the final client of the enormous amount of data collected.
    </Paragraph>
    <Paragraph>
      Experimenting with the different approaches of implementing <Accent>D3 in a React code base</Accent>, each having pros and cons in terms of simplicity, animation and performance, the most natural was to be using <Accent>D3 for the math, React for the DOM</Accent>.
    </Paragraph>
  </>
);

DataVisualization.propTypes = {};

export default DataVisualization;
